<template>
  <FlexTable class="weekly-consumption-table">
    <div class="flex-th table-title">Indique cuántos días a la semana consume estos alimentos</div>
    <div class="flex-trow flex-trow-header">
      <div class="flex-th">Alimento</div>
      <div class="flex-th">Veces por semana</div>
      <div class="flex-th details-th">Tipo</div>
    </div>
    <div class="flex-trow flex-trow-content">
      <div class="flex-td">
        Ej: Lácteos
      </div>
      <div class="flex-td">
        3 días (3 / 7)
      </div>
      <div class="flex-td details-td">
        Leche descremada
      </div>
    </div>

    <div 
      v-for="(weeklyConsumption, index) in value"
      :key="weeklyConsumption.food"
      class="flex-trow flex-trow-content">
      <div class="flex-td">
        {{ getFoodName(weeklyConsumption.food) }}
      </div>
      <div class="flex-td editable-cell">
        <EditableCellSelect
          v-model="weeklyConsumption.trend"
          :units="optionsTrendTimes"
          :disabled="disabled"
        />
      </div>
      <div class="flex-td details-td editable-cell">
        <EditableCellInput 
          v-model="weeklyConsumption.details"
          :is-textarea="true" 
          :disabled="disabled"
          :state="$v.formData.$each[index].details.$invalid ? false : null "
        />
      </div>
    </div>
  </FlexTable>
  
</template>

<script>
import FlexTable from "./base/FlexTable";
import EditableCellInput from "../EditableCellInput";
import EditableCellSelect from '../EditableCellSelect';
import { maxLength } from 'vuelidate/lib/validators';

export default {
  name: "WeeklyConsumptionTable",
  components: { EditableCellSelect, EditableCellInput, FlexTable },
  props: {
    value: Array,
    optionsTrendTimes: Array,
    optionsTrendFoods: Array,
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      formData: this.value,
    }
  },
  validations: {
    formData: {
      $each: {
        details: {
          maxLength: maxLength(300)
        }
      }
    }
  },
  methods: {
    getFoodName(foodId) {
      return this.optionsTrendFoods.find(food => food.value === foodId).text
    },
    loadData(data) {
      this.formData = data;
    },
    validate() {
      this.$v.formData.$touch();
      var isValid = !this.$v.formData.$invalid
      this.$emit('on-validate', isValid)
      return isValid
    }
  }
}
</script>

<style scoped lang="scss">
$weekly-consumption-table-base-color: $dark-blue;
$weekly-consumption-table-title-bg-color: $weekly-consumption-table-base-color;
$weekly-consumption-table-title-color: $white;
$weekly-consumption-table-header-bg-color: rgba($weekly-consumption-table-base-color, 0.1);
$weekly-consumption-table-header-color: darken($weekly-consumption-table-base-color, 25);

.weekly-consumption-table {
  overflow-x: auto;
  padding: 4px;
  width: 100%;
  flex-direction: column;
  margin-bottom: 1rem;
}

.flex-th.table-title {
  background-color: $weekly-consumption-table-title-bg-color;
  color: white;
  position: sticky;
  left: 0;
  width: 100%;
}

.flex-th {
  background-color: $weekly-consumption-table-header-bg-color;
  color: $weekly-consumption-table-header-color;
  padding: 0.25rem;
}

.flex-trow-header > .flex-th, .flex-trow-content > .flex-td {
  flex: 1 0 6rem;
}

.flex-trow-header > .flex-th.num-cell, .flex-trow-content > .flex-td.num-cell {
  flex: 1 0 6rem;
}

.flex-trow-header > .flex-th.details-th, .flex-trow-content > .flex-td.details-td {
  flex: 1 0 27rem;
}

.with-unit {
  position: relative;

  & input {
    padding-top: 0;
    padding-bottom: 1rem;
  }

  & select {
    display: block;
    color: $gray-500;
    font-size: $font-size-sm;
    position: absolute;
    top: 50%;
    line-height: 1.3em;

    &:hover:not([disabled]) {
      color: $body-color;
    }

    &:hover[disabled] {
      background-color: transparent;
      cursor: unset;
    }

    &:active, &:focus {
      color: $body-color;
      background-color: $active-background-color;
    }
  }
}

// Hide incremental arrows
/* Chrome, Safari, Edge, Opera */
.editable-cell input::-webkit-outer-spin-button,
.editable-cell input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.editable-cell input[type=number] {
  -moz-appearance: textfield;
}
</style>